$(document).ready(function(){
  $('.digital_coloring--wrapper-slider').slick({
    // arrows: true,
    variableWidth: true,
    infinite: true,
    slidesToScroll: 2,
    swipeToSlide: false,
    touchThreshold: 20,
    autoplay: false,
    nextArrow: '<i class="fas fa-arrow-circle-right slick-next"></i>',
    prevArrow: '<i class="fas fa-arrow-circle-left slick-prev"></i>',
  });
  $('.recommended__products--wrapper').slick({
    arrows: false,
    centerMode: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          autoplay: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.bar__wrapper').slick({
    slidesToShow: 5,
    arrows: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          autoplay: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });


  // custom related product slider
  $('.custom__related--products .related-products-wrapper').slick({
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });



function moveInputBeforeLabel(input) {
    const parent = input.parentNode;
    const buttonWrap = parent.querySelector('.storemapper_btn-wrap');

    if (buttonWrap && buttonWrap.parentNode === parent) {
        const firstChild = buttonWrap.firstChild; // Get the first child of buttonWrap
        if (firstChild) {
            buttonWrap.insertBefore(input, firstChild);
        } else {
            buttonWrap.appendChild(input);
        }
    } else {
        console.warn("buttonWrap is not a valid child of the parent");
    }
  }
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches('#storemapper-list .tier .storemapper-url')) {
            moveInputBeforeLabel(node);
          }
          const inputs = node.querySelectorAll('#storemapper-list .tier .storemapper-url');
          inputs.forEach(input => moveInputBeforeLabel(input));
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const initialInputs = document.querySelectorAll('#storemapper-list .tier .storemapper-url');
  initialInputs.forEach(input => moveInputBeforeLabel(input));

// logo slider start
    $('.logo-list-section .logo-list-row').slick({
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      pauseOnHover: false,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
 // logo slider over 
});


// New related product slider
 function initializeSlick() {
   
     jQuery('.related_product_slider .product__item_slider').slick({
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        adaptiveHeight: true,
        responsive: [
        {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }

 jQuery(document).ready(function() {   
    initializeSlick();
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          setTimeout(function() {
            initializeSlick();
          }, 300);
        }
      });
    });

    var targetNode = document.querySelector('.related_product_slider');
    if (targetNode) {
      observer.observe(targetNode, { childList: true, subtree: true });
    }

    $(document).on('shopify:section:load', function(event) {
      initializeSlick();
    });
  });

jQuery(window).on('resize', function() {
var $slider = jQuery('.related_product_slider .product__item_slider');
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
    initializeSlick();
  }
});

jQuery(document).ready(function() {
    jQuery(document).on('click', '.swatch_dropdown_custom , .custom-icon', function() {
        jQuery('.select_custom_ul').toggle();
    });
    jQuery(document).on('click', '.select_custom_ul li', function(e) {
        e.preventDefault();
        let datavalue = jQuery(this).attr('value');
        jQuery(".selected_text").text(datavalue);
        jQuery('.select_custom_ul').hide();
        var selectElement = document.querySelector('.select__select_hidden');
        if (selectElement) {
            var option = selectElement.querySelector(`option[value='${datavalue}']`);
            if (option) {
                option.selected = true;
                var changeEvent = new Event('change', {
                    bubbles: true
                });
                selectElement.dispatchEvent(changeEvent);
            } else {
                console.log('Option with value', datavalue, 'not found');
            }
        } else {
            console.log('Select element not found');
        }
    });
});
document.addEventListener('DOMContentLoaded', () => {
    const variantJSONScript = document.getElementById('VariantImageJson');
    if (variantJSONScript) {
        const productVariants = JSON.parse(variantJSONScript.textContent);
        const labels = document.querySelectorAll('.select_custom_ul li');
        labels.forEach(label => {
            const labelText = label.getAttribute("value");
            const matchingVariant = productVariants?.find(variant => variant.title.includes(labelText));
            if (matchingVariant) {
                const imageElement = label.querySelector('.variant_image');
                if (imageElement) {
                      if(matchingVariant.image){
                        imageElement.style.display = "block";
                        imageElement.src = window.location.origin + "/cdn/shop/" + matchingVariant.image + "?width=50";
                      }
                      else{
                       imageElement.style.display = "none";   
                    }
                } else {
                    console.error('No image element found inside:', label);
                }
            }
        });
    }
});

